import api from './api';

export const exportService = {
  // Lädt die Excel-Arbeitsmappe eines Friedhofs (Gräber, Tiere, Kunden, Verträge)
  // und stößt im Browser den Download an.
  downloadExcel: async (friedhofId: number): Promise<void> => {
    const response = await api.get('/export/excel', {
      params: { friedhofId },
      responseType: 'blob',
    });

    // Dateiname aus dem Content-Disposition-Header lesen, sonst Fallback.
    const disposition: string = response.headers['content-disposition'] || '';
    const match = disposition.match(/filename="?([^"]+)"?/);
    const filename = match?.[1] || 'tierfriedhof-export.xlsx';

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};

export default exportService;
